import styled from "styled-components";

export default styled.textarea`
  background-color: #efefef;
  border-radius: 10px;
  border: none;
  padding: 0.4rem 1rem;
`;
